import {writable} from "svelte/store";
const trainerWorkoutsCount = writable(0);
export {trainerWorkoutsCount};
